import React, {useEffect, useState} from 'react';
import s from './styles.module.css'
import {observer} from "mobx-react-lite";
import {useStore} from "../../../hooks/useStore";
import classNames from "classnames";
import {toast} from "react-toastify";
import {CircularProgress, FormControl, MenuItem, Select, Switch} from "@mui/material";
import FigureBox2 from "../figure_box_2";
import AlertDialog from "../../../components/dialog_modal";
import api from "../../../api/api";
import FigureTable from "./FigureTable";

const FigureBox = observer(({
                                id_disciplin,
                                id_group,
                                socketData,
                                judgleStatus,
                                setOpenDialogCustom,
                                setCoachTypeId,
                                setCoachTypeNumber,
                            }) => {
    const {figure} = useStore()

    const [value, setValue] = useState('')
    const [checked, setChecked] = useState(false)
    const [openDialog, setOpenDialog] = React.useState(false);
    const [sportsmanName, setSportsmanName] = React.useState(false);
    const [applicationFigureId, setApplicationFigureId] = React.useState(false);
    const [visualRecalculate, setVisualRecalculate] = useState(false);
    const [visualSearch, setVisualSearch] = useState(false);

    const [figureData, setFigureData] = useState(figure)

    const handleClickSearch = async () => {
        setVisualSearch(true);
        if (value === '') {
            // toast.error('Минимальная длина один символ')
            await figure.getCommand(id_group)
            setVisualSearch(false);
            return
        }
        await figure.getCommandByName(value.trim(), id_group)
        setVisualSearch(false);
    }

    const handleClickRecalclulate = async () => {
        setVisualRecalculate(true);
        await figure.getRecalclulate(id_group).then((res) => {
            if (res?.status === 'ok') {
                figure.getCommand(id_group)
                toast.success('Готово')
            }
        })
        setVisualRecalculate(false);
    }

    useEffect(() => {
        figure.getCommand(id_group)
        figure.getFigure(id_group)
    }, [id_group, checked])

    useEffect(() => {
        let elementsByClassName = document.getElementById("figureItem");
        if (checked) return;
        if (elementsByClassName == null) return;
        if (socketData?.method === "update_user_figure") {
            const getUpdateScor = async () => {
                const res = await api().get(`/figure/user/${socketData?.application_figure_id}`)

                setFigureData({
                    ...figureData,
                    commands: {
                        ...figureData?.commands,
                        application_figure: figureData?.commands?.application_figure?.map((el) => el?.application_figure_id === res.data?.application_figure_id ? (res.data) : el)
                    }
                })
            }
            getUpdateScor()

        }
    }, [socketData, figure, checked])

    useEffect(() => {
        figure.getCommand(id_group)
    }, [id_group])

    useEffect(() => {
        setFigureData(figure)
    }, [figure])

    const clearScore = async () => {
        setOpenDialog(false)
        await api().get(`/figure/clean_score/${applicationFigureId}`).then((res) => {
            if (res?.data?.status === 'ok') {
                toast.success('Оценки спортсмена очищены')
            }

            if (res?.data?.status === 'error') {
                toast.error(res?.data?.msg)
            }
        })
        const res = await api().get(`/figure/user/${applicationFigureId}`)
        setFigureData({
            ...figureData,
            commands: {
                ...figureData?.commands,
                application_figure: figureData?.commands?.application_figure?.map((el) => el?.application_figure_id === res.data?.application_figure_id ? (res.data) : el)
            }
        })
    }

    const handleChange = async (event, el) => {
        let body = {
            competition_application_figure_id: el.competition_application_figure_id,
            is_not_started: null,
            is_disqualified: null
        }
        if (event.target.value === '---') {
            body.is_not_started = 0;
            body.is_disqualified = 0;
        } else if (event.target.value === 'DNS') {
            body.is_not_started = 1;
            body.is_disqualified = 0;
        } else if (event.target.value === 'DSQ') {
            body.is_not_started = 0;
            body.is_disqualified = 1;
        }

        if (body.is_not_started !== null && body.is_disqualified !== null) {
            console.log("Request")
            // const res = await api().patch('/change-not-started-or-disqualified', body);
            // console.log(res);
        }
    };

    return (
        <div className={s.warpper}>
            <AlertDialog
                title={`Очистить все оценки спортсмена ${sportsmanName}?`}
                open={openDialog} setOpen={setOpenDialog} handlerConfirm={clearScore}/>
            <div className={s.content}>

                <div className={s.navigate}>
                    <div className={s.search}>
                        {!checked && <>
                            <input className={s.input} type="text" value={value}
                                   onChange={(e) => setValue(e.target.value)}/>
                            <button disabled={visualSearch} className={s.btn}
                                    onClick={handleClickSearch}>
                                Найти
                                {visualSearch &&
                                    <CircularProgress
                                        style={{position: "absolute", marginLeft: "75px", marginTop: "20px"}}
                                        size="12px" color="inherit"/>}
                            </button>
                            <button disabled={visualRecalculate} className={s.btn_calc}
                                    onClick={handleClickRecalclulate}>
                                Подсчитать
                                {visualRecalculate &&
                                    <CircularProgress
                                        style={{position: "absolute", marginLeft: "120px", marginTop: "20px"}}
                                        size="12px" color="inherit"/>}
                            </button>
                        </>}
                    </div>

                    <div className={s.switch}>
                        <p>{checked ? 'Спортсмены' : 'Фигуры'}</p>
                        {
                            <Switch
                                style={{color: ((document.getElementById("figureItem") || document.getElementById("figure_content"))) && '#1381e5'}}
                                disabled={(!(document.getElementById("figureItem") || document.getElementById("figure_content")))}
                                checked={checked} onChange={(e) => setChecked(e.target.checked)}/>
                        }
                    </div>
                </div>

                {!checked ? <div className={s.table}>
                    {figureData?.commands?.application_figure?.map((el, i) => {
                        return <FigureTable
                            el={el}
                            i={i}
                            figure={figure}
                            figureData={figureData}
                            setOpenDialog={setOpenDialog}
                            setSportsmanName={setSportsmanName}
                            setApplicationFigureId={setApplicationFigureId}
                            isNotStarted={el?.is_not_started}
                            isDisqualified={el?.is_disqualified}
                        />
                    })}

                </div> : <FigureBox2
                    socketData={socketData}
                    id={id_group}
                    judgleStatus={judgleStatus}
                    setOpenDialogCustom={setOpenDialogCustom}
                    setCoachTypeId={setCoachTypeId}
                    setCoachTypeNumber={setCoachTypeNumber}
                />}
            </div>
        </div>
    );
});

export default FigureBox;
